import React, { useState } from "react";
import Modal from "react-modal";
import PaymentLinkTable from "../../payment-link-system/PaymentLinkTable";
import {
  convertThenFormat,
  formatDateTimezon,
} from "../../common-data/Converts";
import ModalHeadAndClose from "../../payouts-wtf/common/ModalHeadAndClose";
import AddLeadForm from "../AddLeadForm";
import RawLeadLogsMobile from "./RawLeadLogsMobile";

const RawLeadLogs = ({
  allData,
  isPage,
  setIsPage,
  userInfoData,
  onReload,
}) => {
  const isMarketing = userInfoData?.account_type === "marketing";

  const { allRawLeadData, rawLeadPagination } = allData || {};
  const iniModvalues = {
    isModOpen: false,
    rowData: "",
    modName: "",
  };
  const [modValues, setModValues] = useState(iniModvalues);

  function onCloseModal() {
    setModValues(iniModvalues);
  }

  const tbColumns = [
    !isMarketing && {
      dataField: "action",
      text: "Action",
      formatter: (cell, row) => (
        <div className="actionButtonContainer">
          <button
            type="button"
            className="actionBtn"
            style={{
              minWidth: "120px",
              background: "#C90808",
              color: "#fff",
              borderRadius: "8px",
              cursor: "pointer",
              fontSize: "15px",
              padding: "10px",
            }}
            onClick={() =>
              setModValues((prevs) => ({
                ...prevs,
                isModOpen: true,
                rowData: row,
                modName: "add",
              }))
            }
          >
            Add To LMS
          </button>
        </div>
      ),
    },
    {
      dataField: "user_id",
      text: "Customer Info",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            {row?.user_name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.user_mobile || ""}
              <br />
              {row?.user_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "gym_id",
      text: "gym name",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            <small>{row?.gym_name || "NA"}</small>
          </span>
        );
      },
    },
    {
      dataField: "plan_name",
      text: "plan",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth150">
            {row?.plan_name || "NA"}
            <br />
            <small style={{ color: "gray" }}>{row?.type || ""}</small>
          </span>
        );
      },
    },
    {
      dataField: "total_amount",
      text: "Amount",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            ₹{convertThenFormat(row?.total_amount || 0)}
          </span>
        );
      },
    },
    {
      dataField: "sub_added_by",
      text: "Sub Added By",
      formatter: (cell, row) => {
        return (
          <span className="tb-data">
            <small style={{ color: "gray" }}>
              {row?.sub_added_by_account_type?.replace(/_/g, " ") || ""}
            </small>
            <br />
            {row?.sub_added_by_name || "NA"}
            <br />
            <small style={{ textTransform: "lowercase" }}>
              {row?.sub_added_by_mobile || ""}
              <br />
              {row?.sub_added_by_email || ""}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "subscription_added",
      text: "Sub Add Date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth100">
            <small>
              {row?.subscription_added
                ? formatDateTimezon(row.subscription_added)
                : "-"}
            </small>
          </span>
        );
      },
    },
    {
      dataField: "subscription_start_date",
      text: "Sub Start/Expire Date",
      formatter: (cell, row) => {
        return (
          <span className="tb-data minWidth180">
            <small>
              {row?.subscription_start_date
                ? formatDateTimezon(row.subscription_start_date)
                : "-"}
              /{" "}
              {row?.subscription_expire_date
                ? formatDateTimezon(row.subscription_expire_date)
                : "-"}
            </small>
          </span>
        );
      },
    },
  ];

  return (
    <>
      <Modal
        isOpen={modValues.isModOpen}
        onRequestClose={onCloseModal}
        contentLabel="Add Modal"
        ariaHideApp={false}
      >
        <div className="createNewCTOModalContainer p-0 mod-width-50p mod-height-95vh">
          {/* <ModalHeadAndClose title="Add New Lead" onClose={onCloseModal} /> */}

          <AddLeadForm
            userInfoData={userInfoData}
            closeModal={onCloseModal}
            callFunction={() => {
              onReload();
            }}
            rowData={modValues.rowData}
            isRawLead={true}
          />
        </div>
      </Modal>

      <div className="fullWidthFlexCenter overflowAuto separatedTable hideMobile">
        <PaymentLinkTable
          tableData={allRawLeadData}
          tableColumns={tbColumns}
          tablePagination={rawLeadPagination}
          isPage={isPage}
          setIsPage={(value) => setIsPage(value)}
        />
      </div>

      <div className="lead-logs-card-container only-mobile">
        <RawLeadLogsMobile
          tableData={allRawLeadData}
          tablePagination={rawLeadPagination}
          isPage={isPage}
          setIsPage={(value) => setIsPage(value)}
          setModValues={setModValues}
          userInfoData={userInfoData}
        />
      </div>
    </>
  );
};

export default RawLeadLogs;
